import {createGlobalContext} from "@acng/frontend-relativity";

export const ctxCamEvent = createGlobalContext(null);
